export const statusContainerContent = [
  {
    title: 'Status audytora',
    role: 'auditor',
  },
  {
    title: 'Moja ocena',
    role: 'client',
  },
]
